module.exports = __webpack_public_path__ + "img/Indonesia-hover.772ba9bd.jpg";